import { render, staticRenderFns } from "./gl-action-link.vue?vue&type=template&id=401a2080&scoped=true"
import script from "./gl-action-link.vue?vue&type=script&lang=js"
export * from "./gl-action-link.vue?vue&type=script&lang=js"
import style0 from "./gl-action-link.vue?vue&type=style&index=0&id=401a2080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401a2080",
  null
  
)

export default component.exports